import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import {
  ElderCardComponent,
  ElderCardTitleDirective,
  ElderCardContentDirective,
  ElderCardHeaderComponent,
} from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-production-hint',
  imports: [
    ElderCardComponent,
    ElderCardTitleDirective,
    ElderCardContentDirective,
    ElderCardHeaderComponent,
  ],
  template: `
    <elder-card>
      <elder-card-header>
        <elder-card-title>{{ title() }}</elder-card-title>
      </elder-card-header>
      <elder-card-content>
        <p class="text-body-medium">{{ body() }}</p>
      </elder-card-content>
    </elder-card>
  `,
})
export class ProductionHintComponent {
  title = input.required<string>()
  body = input.required<string>()
}
